<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :subTitle="subTitle" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <McButtonBack href="/master/" />
      </div>

      <b-card class="mc-card mc-card__setting mc-card__setting--rfid">
        <b-tabs content-class="p-3 text-muted">
          <!-- Tag Tab -->
          <RFIDTagTab />

          <!-- Reader Tab-->
          <RFIDReaderTab />
        </b-tabs>
      </b-card>
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import { mapGetters } from 'vuex'
import McButtonBack from '@/components/McButtonBack'
import { Helper } from '@/mixin/helper'
import RFIDTagTab from '@/router/views/master/rfid/component/TagTab'
import RFIDReaderTab from '@/router/views/master/rfid/component/ReaderTab'
export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    RFIDTagTab,
    RFIDReaderTab,
  },
  mixins: [Helper],
  data() {
    return {
      selectedTab: 'tag',
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return `${this.$t('master.rfid.title')}`
    },
    subTitle() {
      return `${this.$t('master.rfid.list')}`
    },
  },
}
</script>
